import { Component, NgZone, OnInit } from "@angular/core";
import { NavigationStart, Router } from "@angular/router";
import {
    DialogRef,
    ModalComponent,
    overlayConfigFactory
} from "angular2-modal";
import { BSModalContext, Modal } from "angular2-modal/plugins/bootstrap";
import * as moment from "moment";
import { TranslateService } from "ng2-translate/ng2-translate";
import { SendMoneyDetail } from "../../../models/sendmoney/sendmoney";
import { AlertService } from "../../../sharedcomponents/commonservice/alert.service";
import { CountryService } from "../../../sharedcomponents/commonservice/countrylist.service";
import { OccupationModal } from "../../../sharedcomponents/commonservice/occupation/occupation/occupation.modal";
import { occupationoppservice } from "../../../sharedcomponents/commonservice/occupation/ocupation.service";
import { utilityService } from "../../../sharedcomponents/commonservice/utility.service";
import {
    AppSettings,
    enumStatusCodeList
} from "../../../sharedcomponents/_common/constants/app.constants";
import { ErrorPopupComponent } from "../../../sharedcomponents/_directive/error-popup/error-popup.component";
import { SendMoneyService } from "../../../_services/sendmoneyservice/sendmoneyservice";
import { userdocserviceopp } from "../../../_services/userservice/user.documentupload.service";
import { StatelistComponent } from "../../../sharedcomponents/_common/countrylist/statelist.component";
import { state } from '../../../sharedcomponents/_common/countrylist/state';
import { CitylistComponent } from "../../../sharedcomponents/_common/countrylist/citylist.component";
import { GoogleAutocompleteComponent } from "../../../sharedcomponents/_common/countrylist/google-autocomplete/google-autocomplete.component";
enum actionType {
    continue = 1,
    moreInfo = 2
}

export class CustomModalContext extends BSModalContext {
    public modalData: any;
}

@Component({
    selector: "app-additional-info-popup",
    templateUrl: "./additional-info-popup.component.html",
    providers: [
        AlertService,
        Modal,
        CountryService,
        userdocserviceopp,
        occupationoppservice,
        utilityService
    ]
})
export class AdditionalInfoPopupComponent
    implements OnInit, ModalComponent<CustomModalContext> {
    sendMoneyDetail: SendMoneyDetail;
    finalOccuppeancyresults = [];

    agentpopupData: any = {};
    model: any = {};
    context: CustomModalContext;
    action: actionType;
    // user
    userCountrycollection: any;
    stateCollection = new Array<state>();
    //selectedState: state;
    userCountryName: any;

    //
    isBeneficiaryInfoExist: boolean = false;
    isUserInfoExist: boolean = false;
    isUserAddressRequired: boolean = false;
    isOtherInfoExist: boolean = false;
    // beneficiary
    beneficiaryCountrycollection: any;
    beneficiaryStateCollection: any;
    beneficiaryCityCollection: any;
    beneficiaryCountryName: any;

    beneficiaryRelations: any;
    transferReasons: any;

    identificationTypelist: any;
    identificationTypelistUser: any;
    identificationTypelistBeneficiary: any;
    identificationList: any;
    identificationCollections: any;
    yearRange: any;
    ocupencycollection = new Array<OccupationModal>();
    appSettings: any = {};
    isOcupencyValid: boolean = false;
    public defaultDate: any;
    public addressSettings: any = {
        showSearchButton: false,
        geoCountryRestriction: ["us"],
        inputPlaceholderText: this.translate.instant("Common_lblSearchFromGoogle"),
        geoTypes: ["establishment", "address", "geocode"]
    };
    BeneficairyphoneminLength;
    BeneficairyphonemaxLength;

    constructor(
        public dialog: DialogRef<CustomModalContext>,
        private router: Router,
        private modal: Modal,
        private countryserv: CountryService,
        private sendMoneyService: SendMoneyService,
        public utilityServ: utilityService,
        private occupencyService: occupationoppservice,
        private userdocService: userdocserviceopp,
        public translate: TranslateService,
        protected zone: NgZone
    ) {
        this.context = dialog.context;
        this.context.dialogClass = "clsAdditionalPopup";
        this.router.events.subscribe(event => {
            if (event instanceof NavigationStart) {
                this.dialog.close();
            }
        });
        this.appSettings = AppSettings;
        const _self = this;
        this.zone.onError.subscribe((e: any) => {
            console.log("Observer got a next value: " + e);
            _self.dialog.close();
        });

        // this.model.userState = '';
        // this.model.userCity = '';
        // this.model.beneficiaryState = '';
        // this.model.beneficiaryCity = '';
        this.context = dialog.context;
        this.sendMoneyDetail = new SendMoneyDetail();
        this.sendMoneyService.getSendMoneyDetailData().subscribe(data => {
            this.sendMoneyDetail = data;
        });

        this.initModelData();

        let self = this;
        // this.model.isuserOccupation = true;
        // this.isUserInfoExist = true;
        this.isOcupencyValid = this.model.isuserOccupation == true ? false : true;
        this.model.userCountry = AppSettings.BaseCountry;
        this.utilityServ.busy = this.userdocService
            .getcountrydoucmenttypelistrequest(this.model.beneficiaryCountry)
            .subscribe(
                data => {
                    this.identificationTypelist = this.userdocService.populateDocumentModelStep1(
                        data
                    );
                    this.identificationTypelistUser = this.identificationTypelist.filter(
                        function (ele) {
                            return ele.ForCustomer == true;
                        }
                    );
                    this.identificationTypelistBeneficiary = this.identificationTypelist.filter(
                        function (ele) {
                            return ele.ForBeneficiary == true;
                        }
                    );
                },
                error => {
                    console.log("Observer got a next value: " + error);
                }
            );

        self.userCountrycollection = self.countryserv.getCountryListFromLocale(); // this.countryserv.getCountryListFromLocaleEx();

        self.userCountryChange(self.model.userCountry);

        let coll = self.userCountrycollection.filter(function (country) {
            return country.CountryCode === self.model.userCountry;
        });

        if (coll.length > 0) {
            self.stateCollection = coll[0].CountryState;
        }

        self.ocupencycollection = self.occupencyService.getoccupationlistLocale();
        self.GetBeneficiaryRelations();
        self.GetTransferReasons();

        // this.userCity(this.model.userState);
        self.beneficiaryCountrycollection = self.countryserv.getCountryListFromLocaleEx();
        self.beneficiaryCountryChange(self.model.beneficiaryCountry);
        self.beneficiaryCity(self.model.beneficiaryState);
    }

    ngOnInit() {
        this.yearRange =
            new Date().getFullYear() - 100 + ":" + (new Date().getFullYear() - 18);
        // this.model.userDOB = moment()
        //   .subtract(100, 'years')
        //   .format('MM/DD/YYYY');
        this.defaultDate = new Date(
            moment()
                .subtract(100, "years")
                .format("MM/DD/YYYY")
        ); //

        this.BeneficairyphoneminLength = AppSettings.phoneminLength;
        this.BeneficairyphonemaxLength = AppSettings.phonemaxLength;

    }

    initModelData() {
        this.model = this.sendMoneyService.initUserBeneficiaryDataFromSendmoneyObject(
            this.sendMoneyDetail,
            this.dialog.context.modalData.page
        );
        if (
            this.model.isuserDOB === true ||
            this.model.isuserCountry === true ||
            this.model.isuserState === true ||
            this.model.isuserCity === true ||
            this.model.isuserAddress === true ||
            this.model.isuserZipcode === true ||
            this.model.isuserOccupation === true ||
            this.model.isuserEmployer === true
        ) {
            this.isUserInfoExist = true;
        }
        if (
            this.model.isuserCountry === true ||
            this.model.isuserState === true ||
            this.model.isuserCity === true ||
            this.model.isuserAddress === true ||
            this.model.isuserZipcode === true
        ) {
            this.isUserAddressRequired = true;
            this.model.userCity = "";
            this.model.userState = "";
            this.model.userAddress = "";
            this.model.userZipcode = "";
        }
        if (
            this.model.beneficiaryAdditionalLastName === true ||
            this.model.isbeneficiaryPhone === true ||
            this.model.isbeneficiaryCountry === true ||
            this.model.isbeneficiaryState === true ||
            this.model.isbeneficiaryCity === true ||
            this.model.isbeneficiaryAddress === true ||
            this.model.isbeneficiaryZipcode === true ||
            this.model.isbeneficiaryRelationship === true ||
            this.model.isbeneficiaryIdentificationNumber === true
        ) {
            this.isBeneficiaryInfoExist = true;
        }
        if (
            this.model.isreasonSendingMoney === true ||
            this.model.isfundSource === true
        ) {
            this.isOtherInfoExist = true;
        }
    }

    search(event) {
        this.isOcupencyValid = this.model.isuserOccupation == true ? false : true;
        let subscription = this.occupencyService.getOccupancyList(`{"Filter":"` + event.query + `", "UpdatedTimeStamp": ""}`).subscribe(data => {
            this.finalOccuppeancyresults = data.Occupations;
            subscription.unsubscribe();
        });
    }

    captureId(obj) {
        this.model.userOccupation = obj.key;
        this.isOcupencyValid = true;
    }

    GetBeneficiaryRelations() {
        this.beneficiaryRelations = this.utilityServ.getBeneficiaryRelations();
    }
    GetTransferReasons() {
        this.transferReasons = this.utilityServ.getTransferReasons();
    }

    userCountryChange(contryCode) {
        if (this.utilityServ.getObjectText(contryCode) != "") {
            const countryObj = this.userCountrycollection.filter(function (country) {
                return country.CountryCode === contryCode;
            });
            this.model.userCountry =
                countryObj.length > 0 ? countryObj[0].CountryCode : "";
        }

        // this.userState();
    }

    beneficiaryCountryChange(contryCode) {
        const countryObj = this.beneficiaryCountrycollection.filter(function (
            country
        ) {
            return country.CountryCode === contryCode;
        });
        this.model.beneficiaryCountry =
            countryObj.length > 0 ? countryObj[0].CountryCode : "";
        if (countryObj.length > 0) {
            this.BeneficairyphoneminLength = countryObj[0].PhoneNumberLength;
            this.BeneficairyphonemaxLength = countryObj[0].PhoneNumberLength;

        }
        this.beneficiaryState();
    }
    beneficiaryState() {
        const countryCode = this.model.beneficiaryCountry;
        const coll = this.beneficiaryCountrycollection.filter(function (country) {
            return country.CountryCode === countryCode;
        });
        this.beneficiaryStateCollection = coll.length > 0 ? coll[0].states : [];
        this.beneficiaryCountryName = "";
        if (coll.length > 0) {
            const countryName = coll[0].CountryNames[0].Name;
            // .filter(function(lang) {
            //   return (
            //     lang.Language.toUpperCase() === sessionStorage.langCode.toUpperCase()
            //   );
            // });
            this.beneficiaryCountryName =
                countryName.length > 0 ? countryName[0].Name : "";
        }
    }

    openBeneficiaryStateBox() {
        let self = this;
        let modalData: any = {};
        modalData.CountryCode = this.model.beneficiaryCountry;
        modalData.StateCollection = this.beneficiaryStateCollection;
        return this.modal
            .open(
                StatelistComponent,
                overlayConfigFactory({ modalData }, BSModalContext)
            )
            .then(function (obj) {
                obj.onDestroy.subscribe(data => {
                    if (modalData.next.StateCode == undefined) {
                    } else {
                        self.model.beneficiaryState = modalData.next.StateCode;
                        self.beneficiaryCity(modalData.next.StateCode);
                    }
                });
            });
    }

    openBeneficiaryCityBox() {
        let self = this;
        let modalData: any = {};
        modalData.CountryCode = this.model.beneficiaryCountry;
        modalData.StateCode = this.model.beneficiaryState;
        modalData.CityCollection = this.beneficiaryCityCollection;
        return this.modal
            .open(
                CitylistComponent,
                overlayConfigFactory({ modalData }, BSModalContext)
            )
            .then(function (obj) {
                obj.onDestroy.subscribe(data => {
                    if (modalData.next.City == undefined) {
                    } else {
                        self.model.beneficiaryCity = modalData.next.City;
                        // self.searchForBranch();
                    }
                });
            });
    }

    beneficiaryCity(stateCode) {
        if (stateCode == "") {
            this.beneficiaryCityCollection = [];
            return;
        }
        // this.model.beneficiaryCity = '';
        this.beneficiaryCityCollection = this.beneficiaryStateCollection.filter(
            function (state) {
                return state.StateCode === stateCode;
            }
        )[0].CityList;
        if (this.beneficiaryCityCollection != null) {
            // this.model.beneficiaryCity = this.beneficiaryCityCollection[0];
        }
    }
    // beneficiaryCity(stateCode) {
    //   const cities = this.beneficiaryStateCollection.filter(function(state) {
    //     return state.StateCode === stateCode;
    //   });
    //   this.beneficiaryCityCollection = cities.length > 0 ? cities[0].Cities : [];
    // }

    save() {
        const _self = this;
        var isPatternMatch = _self.isPatternMatchWithCriteria(); // false;

        if (this.model.userDOB != undefined && this.model.userDOB != null) {
            this.model.userDOB = moment(this.model.userDOB).format("MM/DD/YYYY");
        }

        if (isPatternMatch === true) {
            const IsBeneficiaryUpdated: boolean =
                this.isBeneficiaryInfoExist == true ? true : false;
            this.utilityServ.busy = this.sendMoneyService
                .saveMissingInfo(_self.model, IsBeneficiaryUpdated)
                .subscribe(
                    data => {
                        if (
                            data.Envelope.Body.MissingInformationResponse.StatusCode == 20001
                        ) {
                            return false;
                        }
                        if (
                            data.Envelope.Body.MissingInformationResponse.StatusCode ==
                            enumStatusCodeList.SUCCESS
                        ) {
                            _self.sendMoneyDetail.additionalInfo.fundSource =
                                _self.model.fundSource;
                            _self.sendMoneyDetail.additionalInfo.reasonSendingMoney =
                                _self.model.reasonSendingMoney;
                            _self.action = actionType.continue;
                            _self.sendMoneyDetail.beneficiaryDetails =
                                data.Envelope.Body.MissingInformationResponse.BeneficiaryDetail;
                            _self.sendMoneyService.setSendMoneyDetailData(
                                _self.sendMoneyDetail
                            );
                            _self.dialog.context.modalData.next =
                                _self.sendMoneyDetail.paymentDetails.paymentType;
                            _self.dialog.context.modalData.onNext = "yes";
                            _self.dialog.close();
                        } else {
                            let modalData: any = {};
                            modalData.Title = _self.translate
                                .instant("Common_lblOops")
                                .toString();
                            modalData.Message = _self.translate
                                .instant("Message_errorMessage")
                                .toString();
                            return _self.modal.open(
                                ErrorPopupComponent,
                                overlayConfigFactory({ modalData }, BSModalContext)
                            );
                        }
                    },
                    error => {
                        console.log("Observer got a next value: " + error);
                    }
                );
        } else {
            let modalData: any = {};
            modalData.Title = _self.translate.instant("Common_lblInfo").toString();
            modalData.Message = this.translate.instant("Common_lblIDNum");
            return _self.modal.open(
                ErrorPopupComponent,
                overlayConfigFactory({ modalData }, BSModalContext)
            );
        }
    }

    isPatternMatchWithCriteria() {
        let isPatternMatch = false;
        if (this.model.isbeneficiaryIdentificationNumber) {
            let identificationCollection = this.identificationCollections.filter(
                item => item.IssuerStateCode === this.model.beneficiaryState
            );
            if (identificationCollection.length <= 0) {
                identificationCollection = this.identificationCollections.filter(
                    item => item.IssuerConCode === this.model.beneficiaryCountry
                );
                // this.alertService.error(
                //   "this document does not support, Please slect other document type"
                // );
                isPatternMatch = false;
                let modalData: any = {};
                modalData.Title = this.translate.instant("Common_lblInfo").toString();
                modalData.Message = this.translate
                    .instant("AdditionalInfo_valdDocAvail")
                    .toString();
                return this.modal.open(
                    ErrorPopupComponent,
                    overlayConfigFactory({ modalData }, BSModalContext)
                );
            }
            this.identificationList = identificationCollection[0];
            for (let element of this.identificationList.Masks) {
                let pat = this.utilityServ.getPattern(
                    element.Prefix,
                    element.Mask,
                    element.Suffix
                );
                let regexp = new RegExp(pat);
                let maskValue = this.model.beneficiaryIdentificationNumber;
                let test = regexp.test(maskValue);
                if (test === true) {
                    isPatternMatch = true;
                    break;
                }
            }
        } else {
            isPatternMatch = true;
        }
        return isPatternMatch;
    }

    identificationTypdeChange() {
        this.userdocService
            .getcountrydoucmenttypelistrequest(
                this.model.beneficiaryCountry,
                this.model.beneficiaryIdentificationType
            )
            .subscribe(data => {
                this.identificationCollections = this.userdocService.populateDocumentModelStep1(
                    data
                );
            });
    }
    closeClick() {
        this.dialog.close();
    }

    autoCompleteCallback(place: any) {
        let addressData: any = {};
        let componentForm = {
            street_number: "short_name",
            route: "long_name",
            locality: "long_name",
            administrative_area_level_1: "short_name",
            country: "long_name",
            postal_code: "short_name"
        };
        if (place.data == undefined) {
            return false;
        }
        let data = place.data.address_components;
        for (var i = 0; i < data.length; i++) {
            var addressType = data[i].types[0];
            if (componentForm[addressType]) {
                switch (addressType) {
                    case "street_number":
                        addressData.address1 = data[i].long_name;
                        break;
                    case "route":
                        addressData.address2 = data[i].long_name;
                        break;
                    case "locality":
                        addressData.city = data[i].long_name;
                        break;
                    case "administrative_area_level_1":
                        addressData.stateName = data[i].long_name;
                        addressData.stateCode = data[i].short_name;
                        break;
                    case "country":
                        addressData.countryCode = data[i].short_name;
                        addressData.countryName = data[i].long_name;
                        break;
                    case "postal_code":
                        addressData.zipcode = data[i].long_name;
                        break;
                    default:
                        break;
                }
            }
        }
        // this.utilityServ.getObjectText(place.data.name) + ', ' +
        this.model.userAddress =
            this.utilityServ.getObjectText(addressData.address1) +
            " " +
            this.utilityServ.getObjectText(addressData.address2);
        this.model.userCity = this.utilityServ.getObjectText(addressData.city);
        this.model.userState = this.utilityServ.getObjectText(
            addressData.stateCode
        );
        this.model.userStateName = this.utilityServ.getObjectText(
            addressData.stateName
        );
        this.model.userZipcode = this.utilityServ.getObjectText(
            addressData.zipcode
        );
    }

    openCityBoxEx() {
        let self = this;
        let modalData: any = {};
        let citySettings = {
            showSearchButton: false,
            geoTypes: ["(cities)"],
            geoCountryRestriction: ["us"],
            inputPlaceholderText: this.translate.instant("Common_lblSearchFromGoogle")
        };
        modalData.userSettings = citySettings;
        return this.modal
            .open(
                GoogleAutocompleteComponent,
                overlayConfigFactory({ modalData }, BSModalContext)
            )
            .then(function (obj) {
                obj.onDestroy.subscribe(data => {
                    if (modalData.addressData == undefined) {
                    } else {
                        // self.model.city = modalData.next.City;
                        let addressData = modalData.addressData;
                        self.model.userCity = self.utilityServ.getObjectText(
                            addressData.city
                        );
                        self.model.userState = self.utilityServ.getObjectText(
                            addressData.stateCode
                        );
                        self.model.userStateName = self.utilityServ.getObjectText(
                            addressData.stateName
                        );
                        self.model.userZipcode = self.utilityServ.getObjectText(
                            addressData.zipcode
                        );
                        // self.searchForBranch();
                    }
                });
            });
    }

    openAddressBox() {
        let self = this;
        let modalData: any = {};
        let addressSettings: any = {
            showSearchButton: false,
            geoCountryRestriction: ["us"],
            inputPlaceholderText: this.translate.instant(
                "Common_lblSearchFromGoogle"
            ),
            geoTypes: ["establishment", "address", "geocode"]
        };
        modalData.userSettings = addressSettings;
        return this.modal
            .open(
                GoogleAutocompleteComponent,
                overlayConfigFactory({ modalData }, BSModalContext)
            )
            .then(function (obj) {
                obj.onDestroy.subscribe(data => {
                    if (modalData.addressData == undefined) {
                    } else {
                        let addressData = modalData.addressData;
                        self.model.userAddress =
                            self.utilityServ.getObjectText(addressData.address1) +
                            " " +
                            self.utilityServ.getObjectText(addressData.address2);
                        self.model.userCity = self.utilityServ.getObjectText(
                            addressData.city
                        );
                        self.model.userState = self.utilityServ.getObjectText(
                            addressData.stateCode
                        );
                        self.model.userStateName = self.utilityServ.getObjectText(
                            addressData.stateName
                        );
                        self.model.userZipcode = self.utilityServ.getObjectText(
                            addressData.zipcode
                        );
                    }
                });
            });
    }

    onStateChanged(event) {

        let self = this;

        if (self.model.userState) {

            let selectedState = self.stateCollection.find(x => {
                return x.statecode == self.model.userState;
            });

            if (selectedState) {
                self.model.userStateName = selectedState.name;
            }

        } else {
            self.model.userStateName = '';
        }   
    }
}



// WEBPACK FOOTER //
// ./src/app/sendmoney/_modalpopup/additional-info-popup/additional-info-popup.component.ts